import { Injectable } from '@angular/core';
import { HttpService } from "../core/http/http.service";
import { DataAccessServiceBase } from "./dataaccess.base.service";
import { ModelStateValidationService } from "./model-state-validation.service";
import { ISystemTable } from '../_entities';

@Injectable()
export class SystemTableService extends DataAccessServiceBase<any> {
    private pSystemTable: string;

    constructor(protected httpService: HttpService,
        protected validationService: ModelStateValidationService) {
        super(httpService, validationService);
    }

    getControllerUrl(): string {
        return `api/systemtable/${this.systemTable}`;
    }

	 get systemTable(): string {
        if (this.pSystemTable == null) {
            throw new Error("systemTable field is not initialized");
        }
        return this.pSystemTable;
    }

	 set systemTable(systemTable: string) {
        this.pSystemTable = systemTable;
    }

    getTable(): Promise<any | void> {
        return this.httpService.get(`${this.getControllerUrl()}/table`)
            .then((table: any) => {
                return this.getTableItem(table);
            });
    }

    private getTableItem(table: any): ISystemTable {
        const item: ISystemTable = {
            systemTable: table["systemTable"],
            title: table["title"] + "",
            group: table["group"] + "",
            hasIdentityColumn: table["hasIdentityColumn"],
            columns: table["columns"]
        };
        return item;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/_services/system-table.service.ts